/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));
    if (this.collection_layout == 'slider') {
      this.createSlider('.slider-gallery--desktop', $section);
    }
    if (this.collection_layout_mobile == 'slider' && $('.slider-gallery--mobile').length > 0) {
      this.createSlider('.slider-gallery--mobile', $section);
    }
  },
  createSlider: function(selector, $section) {
    const $sliders = $section.find(selector);
    $sliders.each((_, el) => {
      const $el = $(el);
      $el.removeClass('is-ready');
      const per = parseInt($el.data('products-per-slide'), 10) || (this.products_per ? parseInt(this.products_per, 10) : 4);
      const $flk = $el.flickity({
        cellSelector: '.gallery-cell',
        cellAlign: 'center',
        contain: false,
        groupCells: false,
        draggable: true,
        freeScroll: false,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: this.products_limit > this.products_per ? true : false,
        initialIndex: 0,
        imagesLoaded: true,
        lazyLoad: 2,
        setGallerySize: true,
        arrowShape: 'M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z'
      });
      $flk.on('ready.flickity', function () {
        $el.addClass('is-ready');
      });
      $el.one('settle.flickity', function () {
        $el.addClass('is-ready');
        $el.flickity('resize');
      });
    });
  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}
/******/ })()
;
